import { ArgumentsCamelCase } from 'yargs'
import { checkIfNewerVersionAvailableAndLog, getCustomComponentLibraryConfig } from '../../util'
import { build } from '../../build_components'
import { getCCLClient } from '../../getCCLClient'
import { BuildError } from '../../buildError'

export const buildCommand = async (argv: ArgumentsCamelCase<{ dev: boolean, 'skip-updates-check': boolean, header?: string[] }>): Promise<void> => {
  const cccc = getCustomComponentLibraryConfig()
  const { name } = cccc

  if (!name) {
    throw new BuildError(
      'Missing required name field in custom component library config (package.json -> retoolCustomComponentLibraryConfig.name must be set)',
    )
  }

  await build(argv.dev)

  await checkIfNewerVersionAvailableAndLog(argv['skip-updates-check'])
}
